(function () {
  var KEY = 'taraah:wishlist';

  // Entries are { handle, at }. A bare string is an entry saved by
  // an earlier version — keep it, undated, rather than dropping a
  // shopper's saves on upgrade.
  function read() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
    return raw.map(function (e) {
      return typeof e === 'string' ? { handle: e, at: null } : e;
    }).filter(function (e) { return e && e.handle; });
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paintCount(list);
  }

  function paintCount(list) {
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = list.length;
    });
  }

  function when(at) {
    if (!at) return 'Saved';
    var days = Math.floor((Date.now() - at) / 86400000);
    if (days <= 0) return 'Saved today';
    if (days === 1) return 'Saved yesterday';
    if (days < 7) return 'Saved ' + days + ' days ago';
    if (days < 14) return 'Saved last week';
    if (days < 60) return 'Saved ' + Math.floor(days / 7) + ' weeks ago';
    return 'Saved ' + Math.floor(days / 30) + ' months ago';
  }

  function paintHearts() {
    var list = read().map(function (e) { return e.handle; });
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.wish) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on);
    });
  }

  // Delegated, so hearts in a filtered grid or a re-rendered rail
  // work without re-binding after every fetch.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.wish;
    var list = read();
    var at = -1;
    list.forEach(function (x, i) { if (x.handle === handle) at = i; });
    if (at === -1) list.unshift({ handle: handle, at: Date.now() });
    else list.splice(at, 1);
    write(list);
    paintHearts();
    renderPage();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wish-clear]')) {
      write([]);
      paintHearts();
      renderPage();
    }
  });

  // Submits each card's own form in turn. One /cart/add.js per line
  // is what Dawn's product-form does anyway, and it keeps the
  // notification behaviour identical to a single add.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wish-addall]')) return;
    var forms = document.querySelectorAll('[data-wish-card] form');
    forms.forEach(function (f, i) {
      setTimeout(function () {
        f.querySelector('[type="submit"]').click();
      }, i * 400);
    });
  });

  function money(cents, sample) {
    var whole = String(Math.round(cents / 100));
    var tail = whole.slice(-3);
    var head = whole.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    var grouped = head ? head + ',' + tail : tail;
    if (!sample) return grouped;
    // Exclusive, never chained: a second replace would run over the
    // first one's output and hit a 0 inside the substituted amount.
    if (sample.indexOf('0.00') !== -1) return sample.replace('0.00', grouped + '.00');
    return sample.replace('0', grouped);
  }

  function summarise(root) {
    var cards = root.querySelectorAll('[data-wish-card]');
    var bar = root.querySelector('[data-wish-summary]');
    var countEl = root.querySelector('[data-wish-shown]');
    var totalEl = root.querySelector('[data-wish-total]');
    var addAll = root.querySelector('[data-wish-addall]');
    if (!bar) return;

    var total = 0, mrp = 0;
    cards.forEach(function (c) {
      total += parseInt(c.dataset.price, 10) || 0;
      mrp += parseInt(c.dataset.mrp, 10) || 0;
    });

    var fmt = bar.dataset.money;
    countEl.textContent = cards.length === 1
      ? '1 piece saved' : cards.length + ' pieces saved';
    totalEl.textContent = mrp > total
      ? money(total, fmt) + ' · you save ' + money(mrp - total, fmt)
      : money(total, fmt);
    if (addAll) {
      addAll.textContent = cards.length > 1
        ? 'Move all ' + cards.length + ' to cart' : 'Move to cart';
    }
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist]');
    if (!root) return;

    var grid = root.querySelector('[data-wish-grid]');
    var empty = root.querySelector('[data-wish-empty]');
    var head = root.querySelector('[data-wish-actions]');
    var bar = root.querySelector('[data-wish-summary]');
    var list = read();

    function showEmpty() {
      grid.innerHTML = '';
      grid.hidden = true;
      if (bar) bar.hidden = true;
      if (head) head.hidden = true;
      empty.hidden = false;
    }

    if (!list.length) return showEmpty();

    // Each card is rendered in its own product's context. Storefront
    // search has no handle field, so a search query matches nothing.
    Promise.all(list.map(function (e) {
      return fetch('/products/' + encodeURIComponent(e.handle) +
                   '?section_id=taraah-wishlist-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      grid.innerHTML = '';

      chunks.forEach(function (c, i) {
        if (!c) return;
        var doc = new DOMParser().parseFromString(c, 'text/html');
        var card = doc.querySelector('[data-wish-card]');
        if (!card) return;
        var strip = card.querySelector('[data-wish-saved]');
        if (strip) strip.textContent = when(list[i].at);
        grid.appendChild(card);
      });

      if (!grid.children.length) return showEmpty();

      grid.hidden = false;
      empty.hidden = true;
      if (bar) bar.hidden = false;
      if (head) head.hidden = false;
      summarise(root);
      paintHearts();
    });
  }

  function init() { paintCount(read()); paintHearts(); renderPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();